import React from 'react';
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {featureInterface} from "./featureInterface";

const FeaturesSetupFeatureContentSku = (props) => {

  const {feature} = props;

  return (
    <div className={"fs-feature__sku" + (feature.sku && feature.sku.length > 15 ? " fs-feature__sku--small" : "")}>
      <span className="fs-feature__sku-title">
        <FormattedMessage id="features.setup.feature.sku" />
      </span>
      <span className="fs-feature__sku-value">{feature.sku || "-"}</span>
    </div>
  )
};

FeaturesSetupFeatureContentSku.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

export default FeaturesSetupFeatureContentSku
